import { render, staticRenderFns } from "./NewConfig.vue?vue&type=template&id=43ff0546&"
import script from "./NewConfig.vue?vue&type=script&lang=js&"
export * from "./NewConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports